// Константы относящиеся к сайту
import useSystemStore from '../systemStore/systemStore'

const Site = {
	protocol: 'https://',
	devRootDomain: 'dev.credu.ai',
	prodRootDomain: 'credu.ai',
	devS3Domain: 'theclub.fra1.cdn.digitaloceanspaces.com',
	prodS3Domain: 'credu.fra1.cdn.digitaloceanspaces.com',
	proxyRootDomain: 'ru-credu.ru',
	proxyS3Domain: 'cdn.ru-credu.ru',
	alwaysUseProxyS3Domain: false,
	// Извлекает домен второго уровня из текущего hostname
	getBackendDomain() {
		const hostname = location.hostname

		// Для localhost возвращаем dev домен
		if (hostname === 'localhost') {
			return this.devRootDomain
		}

		// Если hostname содержит dev.credu.ai, возвращаем dev домен (develop окружение)
		if (hostname.includes('dev.credu.ai')) {
			return this.devRootDomain
		}

		// Разбиваем hostname на части
		const parts = hostname.split('.')

		// Если hostname имеет формат subdomain.domain.tld
		if (parts.length >= 3) {
			// Извлекаем domain.tld (последние две части)
			const domain = parts.slice(-2).join('.')
			return domain
		}

		// Если hostname имеет формат domain.tld, возвращаем его как есть
		if (parts.length === 2) {
			return hostname
		}

		// Fallback на prod домен
		return this.prodRootDomain
	},

	// Главный домен для backend API
	get rootDomain() {
		return this.getBackendDomain()
	},
	// Домен школы: testovaya1.dev.credu.ai
	get schoolDomain() {
		return useSystemStore.getState().school.domain
	},
	// домен S3 хранилища
	get storageDomain() {
		return location.hostname == 'localhost' ||
			location.hostname.includes(this.devRootDomain)
			? this.devS3Domain
			: this.prodS3Domain
	},
	// Пример номера телефона для полей формы
	examplePhone: '+1 999 999 99 99',
	// Пример почты для полей формы
	exampleEmail: 'mail@mail.com',
}

export default Site
